import type { NavigateFunction } from "react-router-dom";

let navigator: NavigateFunction | null = null;

export const setNavigator = (nav: NavigateFunction) => {
	navigator = nav;
};

export const navigate = (path: string, options?: { replace?: boolean }) => {
	if (!navigator) {
		console.error("Navigator not set yet!");

		return;
	}

	// optional: allow only known routes

	const _allowedRoutes = ["/auth"];

	if (path !== "/auth") {
		console.warn(`Blocked navigation to unknown route: ${path}`);

		navigator("*", { replace: true });

		return;
	}

	navigator(path, options);
};
